import type { LocationsCounters } from '@recruitee/locations-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<LocationsCounters>()('LocationsCounters');

export {
  selectors as LocationCountersSelectors,
  actions as LocationCountersActions,
  reducer as LocationCountersReducer,
  namespace as LocationCountersNamespace,
};
